import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { suggestionAction } from 'store';
import { selectSuggestions } from 'store/suggestions/selector';
import { Images } from 'assets/images';
import { useCustomNavigation } from 'hooks';
import {
  CardText,
  FlexContainer,
  InfoSection,
  InfoWrapper,
  MessageInfoImage,
  OfferInfo,
  SampleInfoText,
  OfferInfoTitle,
  StyledOfferItemContainer,
  StyledTitle,
  TitleAndPrice,
  OfferInfoText,
} from 'containers/Requests/fragments/RequestsCountries/fragments/RequestsOffer/OfferItem/styled';
import {
  SuggestionFullWrapper,
  SuggestionContent,
  SuggestionImage,
  BackArrow,
  BackArrowImg,
} from './styled';

export const Suggestion = () => {
  const { id } = useParams();
  const suggestion = useSelector(selectSuggestions);
  const dispatch = useDispatch();
  const { back } = useCustomNavigation();

  useEffect(() => {
    dispatch(suggestionAction.getSuggestion(id));
  }, [dispatch]);

  return (
    <SuggestionFullWrapper>
      <SuggestionContent>
        <StyledOfferItemContainer>
          <BackArrow>
            <BackArrowImg src={Images.backVectorIcon} onClick={() => back()} />
          </BackArrow>
          <InfoSection isSuggestion>
            <InfoWrapper isSuggestion>
              <MessageInfoImage isSuggestion>
                <SuggestionImage src={suggestion?.main_image} alt="icon" />
              </MessageInfoImage>

              <OfferInfo isSuggestion>
                <StyledTitle>{suggestion?.title}</StyledTitle>

                <TitleAndPrice suggestion>
                  <FlexContainer />
                </TitleAndPrice>

                <CardText>
                  <SampleInfoText Suggestion>
                    <OfferInfoTitle>Description:</OfferInfoTitle>
                    <OfferInfoText
                      dangerouslySetInnerHTML={{
                        __html: suggestion?.description,
                      }}
                    />
                  </SampleInfoText>
                </CardText>

                <CardText>
                  <SampleInfoText>
                    <OfferInfoTitle>Address:</OfferInfoTitle>
                    <OfferInfoText>{suggestion?.address}</OfferInfoText>
                  </SampleInfoText>
                </CardText>
              </OfferInfo>
            </InfoWrapper>
          </InfoSection>
        </StyledOfferItemContainer>
      </SuggestionContent>
    </SuggestionFullWrapper>
  );
};
